define('model/document.answer.model',['require','exports','module','underscore','fukit','fukit'],function(require, exports, module) {
  //prettier-ignore
  var _                = require('underscore'),
    BaseModel          = require('fukit').BaseModel,
    SaveableCollection = require('fukit').SaveableCollection;

  var DocumentAnswerModel = BaseModel.extend({
    radioRequests: {
      'models DocumentAnswer': '@constructor',
    },

    urlRoot: '/api/v1/eform/answer',
  });

  DocumentAnswerModel.BulkSaveCollection = SaveableCollection.extend({
    url: '/api/v1/eform/answer/bulk',
    model: DocumentAnswerModel,
    save: function(attrs, options) {
      return SaveableCollection.prototype.save.call(
        this,
        attrs,
        _.extend(
          {
            isFromServer: true,
            requestTimestamp: new Date().getTime(),
            reset: false,
          },
          options
        )
      );
    },
  });

  module.exports = DocumentAnswerModel;
});

